import React from 'react'

import styles from './pricing-table.module.scss'
import basicViews from '../../img/basic-views.svg'
import standardViews from '../../img/standard-views.svg'
import premiumViews from '../../img/premium-views.svg'
import {combine} from '../styles/classname-utils'

const PricingTable = () => (
  <div className={styles.table}>
    <div className={styles.rightBorder}>
      <span className={combine('text8-lg', styles.name)}>Basic</span>
    </div>
    <div className={styles.licenseCost}>
      <span>
        <span className={styles.licenseCostValue}>$1,250 / </span> month
      </span>
    </div>
    <div className={styles.licenseViewCol}>
      <span className={styles.licenseView}>
        <img className={styles.licenseViewIcon} src={basicViews} alt='basic views' />
        <b>
          <span className={styles.licenseViewCount}>25,000</span>
        </b>
        <b>views</b>
        included
      </span>
    </div>
    <div className='text8-xs'>
      <span>
        ($0.01 / additional view)
      </span>
    </div>


    <div className={styles.rightBorder}>
      <span className={combine('text8-lg', styles.name)}>Standard</span>
    </div>
    <div className={styles.licenseCost}>
      <span>
        <span className={styles.licenseCostValue}>$3,000 / </span> month
      </span>
    </div>
    <div className={styles.licenseViewCol}>
      <span className={styles.licenseView}>
        <img
          className={styles.licenseViewIcon}
          src={standardViews}
          alt='standard views'
        />
        <b>
          <span className={styles.licenseViewCount}>500,000</span>
        </b>
        <b>views</b>
        included
      </span>
    </div>
    <div className='text8-xs'>
      <span>
        ($0.01 / additional view)
      </span>
    </div>


    <div className={combine(styles.rightBorder, styles.premiumCell)}>
      <span className={styles.licenseBestValue}>BEST VALUE</span>
      <span className={combine('text8-lg', styles.name)}>Premium</span>
    </div>
    <div className={styles.licenseCost}>
      <span>
        <span className={styles.licenseCostValue}>$5,000 / </span> month
      </span>
    </div>
    <div className={styles.licenseViewCol}>
      <span className={styles.licenseView}>
        <img
          className={styles.licenseViewIcon}
          src={premiumViews}
          alt='premium-views'
        />
        <b>
          <span className={styles.licenseViewCount}>1 MILLION</span>
        </b>
        <b>views</b> included
      </span>
    </div>
    <div className='text8-xs'><span>($0.0025 / additional view)</span></div>

  </div>
)

export default PricingTable
